"use strict";

module.exports = function parseSilkRibbonSpools(transaction) {
  var quantity = transaction.quantity;
  var ribbon_spool_color;
  transaction.variations.forEach(function (_ref) {
    var name = _ref.formatted_name,
        value = _ref.formatted_value;

    if (name.match(/color/i)) {
      ribbon_spool_color = value;
    }
  });
  this.ribbonSpools.add({
    quantity: quantity,
    ribbon_spool_color: ribbon_spool_color
  });
};